import { TextField, Tooltip } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  ExporttoExcelAmcReport,
  getAmcReport,
  getEngagementDaya,
  getCustomerData,
  getApplicationData,
} from "../../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import axios from "axios";
import fileDownload from "js-file-download";

const AmcReport = () => {
  let formErrorObj = {};
  const [formErrors, setFormErrors] = useState({});
  const [gridData, setGridData] = useState<any>([]);

  const [engagementSelectedData, setEngagementSelectedData] = useState([]);

  const [customerSelectedData, setCustomerSelectedData] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [engagementOptions, setEngagementOptions] = useState([]);
  const [applicationOptions, setApplicationOptions] = useState([]);//mahesh
  const [applicationSelectedData, setApplicationSelectedData] = useState([]);//mahesh
  
  const [postObject, setPostObject] = useState({});

  const [fromDate, setFromDate] = useState<Date | null>(
    //moment().startOf("month").toDate()
    null
  );

  const [toDate, setToDate] = useState<Date | null>(
    //moment().endOf("month").toDate()
    null
  );
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageSize, setpageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [reset, setReset] = useState(false);
  const [page, setPage] = useState(0);
  const { RoleId, EmployeeId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const [employeeRoleId, setEmployeeRoleId] = useState(0);
  useEffect(() => {
    onLoadApi();
  }, []);

  const onLoadApi = async () => {
    if(RoleIdArray.includes("3")){
      setEmployeeRoleId(3);
    }else if(RoleIdArray.includes("8")){
      setEmployeeRoleId(8);
    }else if(RoleIdArray.includes("2")){
      setEmployeeRoleId(2);
    }else if(RoleIdArray.includes("1")){
      setEmployeeRoleId(1);
    }
    await GetEngagementData();
    await GetCustomersData();
    await GetApplicationData();
  };

  useEffect(() => {
    // GetEngagementData()
    (async () => {
      if (fromDate && toDate) {
        let engagement = await ConvertArrayToString(engagementSelectedData);
        let customers = await ConvertArrayToString(customerSelectedData);
        let application =  await ConvertArrayToString(applicationSelectedData);
      
        let allocatedEngID = engagementOptions.map((obj:any)=>obj.value);
        let allocatedCustID = customerOptions.map((obj:any)=>obj.value);
        let allocatedApplID = applicationOptions.map((obj:any)=>obj.value);
        
      

        let obj = {
          Engagement: engagement,
          Customers: customers,
          Application: application, // added by mahesh
          //AllocatedEngID:allocatedEngID.join(','),
          //AllocatedCustID:allocatedCustID.join(','),
          //AllocatedApplID: allocatedApplID.join(','),
          FromDate:
            fromDate === null
              ? null
              : moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate:
            toDate === null
              ? null
              : moment(toDate).format(moment.HTML5_FMT.DATE),
          RoleId : employeeRoleId,
          EmployeeId : EmployeeId,
          sortColumn,
          sortOrder,
          searchText,
          pageSize,
          start,
          count,
        };
        await GetGridData(obj);
      }
    })();
  }, [start, sortColumn, sortOrder, searchText, reset, pageSize, page]);

  const GetGridData = async (obj) => {
    showLoader();
    const { data } = await APICall(getAmcReport, "POST", obj);
   

    let arr = [];
    if (data.length > 0) {
      arr = [...data];
      setGridData(data);
    }
    if (arr.length > 0) {
      setCount(arr[0].totalCount);
    } else {
      setStart(0);
      setCount(0);
      setPage(0);
      setGridData([]);
    }
    hideLoader();
  };

  const SelectOnChange = (event, apiField) => {
    if (apiField == "engagement") {
      setEngagementSelectedData(event);
    }
    if (apiField == "fromDate") {
      setFormErrors((prev) => {
        return { ...prev, fromDate: null };
      });
      setFromDate(event);
    }
    if (apiField == "toDate") {
      setFormErrors((prev) => {
        return { ...prev, toDate: null };
      });
      setToDate(event);
    }

    if (apiField == "customer") {
      setCustomerSelectedData(event);
    }
    if (apiField == "application") {
      setApplicationSelectedData(event);
    }
  };

  const GetEngagementData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        RoleId: 3,
        searchValue: EmployeeId,
      };
    } else if (RoleIdArray.includes("8")) { //added by mahesh on 14/10/2024 
      postObject = {
        RoleId: 8,
        Id: EmployeeId,
      };
    } else if (RoleIdArray.includes("2")) {
      postObject = {
        RoleId: 2,
        Id: EmployeeId,
      };
    } else if (RoleIdArray.includes("1")) {
      postObject = {
        RoleId: 1,
        Id: EmployeeId,
      };
    }

    const { data } = await APICall(getEngagementDaya, "POST", postObject);

    if (data != undefined || data != null) {
      let engagementArrya = [];
      let s = "";
      s.toLowerCase();
      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.engagement,
        };
        engagementArrya.push(tempObj);
      });
      engagementArrya.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
     
     
      setEngagementOptions(engagementArrya);
    }
  };
  // added by mahesh 
  const GetApplicationData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        RoleId: 3,
        Id: EmployeeId,
      };
    } else if (RoleIdArray.includes("8")) { 
      postObject = {
        RoleId: 8,
        Id: EmployeeId,
      };
    } else if (RoleIdArray.includes("2")) {
      postObject = {
        RoleId: 2,
        Id: EmployeeId,
      };
    } else if (RoleIdArray.includes("1")) {
      postObject = {
        RoleId: 1,
        Id: EmployeeId,
      };
    }

    const { data } = await APICall(getApplicationData, "POST", postObject);

    if (data != undefined || data != null) {
      let applicationArray = [];
      let s = "";
      s.toLowerCase();
      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.application,
        };
        applicationArray.push(tempObj);
      });
      applicationArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
     
     
      setApplicationOptions(applicationArray);
    }
  };
  //end 

  

  const GetCustomersData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        RoleId: 3,
        searchValue: EmployeeId,
      };
    } else if (RoleIdArray.includes("8")) { // added by mahesh on 14/10/2024 for oprmnger
      postObject = {
        RoleId: 8,
        Id: EmployeeId,
      };
    }
    else if (RoleIdArray.includes("2")) {
      postObject = {
        RoleId: 2,
        Id: EmployeeId,
      };
    } else if (RoleIdArray.includes("1")) {
      postObject = {
        RoleId: 1,
        Id: EmployeeId,
      };
    }

    const { data } = await APICall(getCustomerData, "POST", postObject);

    if (data != undefined || data != null) {
      let customerArray = [];
      let s = "";
      s.toLowerCase();
      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.customer,
        };
        customerArray.push(tempObj);
      });
      customerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setCustomerOptions(customerArray);
    }
  };

  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.value));
    return s.join(",");
  };

  const gridColumns = [
   
    {
      name: "customer",
      label: "Customer",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "priority",
      label: "Priority",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "isChargeable",
      label: "Is Chargeable",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "reportDate",
      label: "Report Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value == null) {
            return <p>null</p>;
          } else {
            // const date = moment(value, 'DD-MM-YYYY HH:mm:ss', true); // 'true' enables strict parsing
            const date = moment(value, ['MM/DD/YYYY hh:mm:ss A', 'M/D/YYYY hh:mm:ss A', moment.ISO_8601], true);
            const formattedDate = date.format('DD-MM-YYYY');
            return <p>{formattedDate}</p>;
          }
        },
      },
    },
   
   
    {
      name: "assignedTo",
      label: "Assigned To",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "hoursAssigned",
      label: "Hours Assigned",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "hoursSpent",
      label: "Hours Spend",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "effectiveHours",
      label: "Effective Hours Spent",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
      },
    },

    
  ];

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      const context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  const onInput = debounce((searchText) => {
    if (searchText !== null) {
      setSearchText(searchText);
    } else {
      setSearchText("");
    }
  }, 1000);

  const object = {
    selectableRows: "none",
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
    
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      onInput(searchText);
    },
    onColumnSortChange: async (sortColumn, sortOrder) => {
      if (sortOrder === "asc") {
        await setSortColumn(sortColumn);
        await setsortOrder(sortOrder);
      }
      if (sortOrder === "desc") {
        await setSortColumn(sortColumn);
        await setsortOrder(sortOrder);
      }
    },
    onChangePage: async (page) => {
      setPage(page);

      setStart(page * pageSize);
    },
  };

  const submitFunc = async (api) => {
    let engagement = await ConvertArrayToString(engagementSelectedData);
    let customers = await ConvertArrayToString(customerSelectedData);
    let application =  await ConvertArrayToString(applicationSelectedData);
    
    let allocatedEngID = engagementOptions.map((obj:any)=>obj.value);
    let allocatedCustID = customerOptions.map((obj:any)=>obj.value);
    let allocatedApplID = applicationOptions.map((obj:any)=>obj.value);
   
    let obj = {
      Engagement: engagement,
      Customers: customers,
      Application: application, // added by mahesh
      //AllocatedEngID:allocatedEngID.join(','),
      //AllocatedCustID:allocatedCustID.join(',') ,
      //AllocatedApplID: allocatedApplID.join(','),  // added by mahesh 

      FromDate:
        fromDate === null
          ? null
          : moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate:
        toDate === null ? null : moment(toDate).format(moment.HTML5_FMT.DATE),
      RoleId : employeeRoleId,
      EmployeeId : EmployeeId,
      sortColumn,
      sortOrder,
      searchText,
      pageSize,
      start,
      count,
    };

    if (api === "submit") {
      let check = Validation();
      if (check) {
        setPostObject(obj);
        await GetGridData(obj);
      } else {
        setFromDate(null);
        setToDate(null);
        setEngagementSelectedData([]);
        setCustomerSelectedData([]);
        setApplicationSelectedData([]);
      }
    }

    if (api === "reset") {
      setFromDate(null);
      setToDate(null);
      setEngagementSelectedData([]);
      setCustomerSelectedData([]);
      setApplicationSelectedData([]);
      setReset(!reset);

    }
  };

  const ExportToExcel = () => {
    let engagement = ConvertArrayToString(engagementSelectedData);
    let customers = ConvertArrayToString(customerSelectedData);
    let application =   ConvertArrayToString(applicationSelectedData);

    //let allocatedEngID = engagementOptions.map((obj:any)=>obj.value);
    //let allocatedCustID = customerOptions.map((obj:any)=>obj.value);
    //let allocatedApplID = applicationOptions.map((obj:any)=>obj.value);
   

   

    

    let obj = {
      Engagement: engagement,
      Customers: customers,
      Application: application, // added by mahesh
      //AllocatedEngID:allocatedEngID.join(','),
      //AllocatedCustID:allocatedCustID.join(','),
      //AllocatedApplID: allocatedApplID.join(','),  // added by mahesh 
      FromDate:
        fromDate === null
          ? null
          : moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate:
        toDate === null ? null : moment(toDate).format(moment.HTML5_FMT.DATE),
      RoleId:employeeRoleId,
      EmployeeId : EmployeeId,
      sortColumn: sortColumn,
      sortOrder: sortOrder,
      searchText: searchText,
      pageSize: count,
      start,
      count: count,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        url: ExporttoExcelAmcReport,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "AMCReport.xlsx");
      })
      .catch((error) => {});
  };

  const Validation = () => {
    let objError = {};

    if (fromDate == undefined || fromDate == null) {
      objError["fromDate"] = "From Date Can Not Be Empty";
    }
    if (toDate == undefined || toDate == null) {
      objError["toDate"] = "To Date Can Not Be Empty";
    }

    if(fromDate && moment(toDate).isBefore(fromDate)){
      objError["toDate"] = "To Date Can Not Be Less Than From Date";
    }

    formErrorObj = objError;
    setFormErrors(objError);
    const isEmpty = Object.keys(objError).length === 0;

    return isEmpty;
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"AMC Report"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Customers</label>
                    <SelectForm
                      value={customerSelectedData}
                      onChange={(e) => SelectOnChange(e, "customer")}
                      options={customerOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Engagement</label>

                    <SelectForm
                      value={engagementSelectedData}
                      onChange={(e) => SelectOnChange(e, "engagement")}
                      options={engagementOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Application</label>

                    <SelectForm
                      value={applicationSelectedData}
                      onChange={(e) => SelectOnChange(e, "application")}
                      options={applicationOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="d-block">
                      From Date <sup>*</sup>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To Date"
                        value={fromDate}
                        onChange={(event) => SelectOnChange(event, "fromDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                    <p style={{ color: "red" }}>{formErrors["fromDate"]}</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      To Date <sup>*</sup>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(event) => SelectOnChange(event, "toDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                    <p style={{ color: "red" }}>{formErrors["toDate"]}</p>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                      // disabled={state !== null ? true : false}
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            {gridData && gridData.length >= 0 && (
              <DynamicGrid
                options={object}
                data={gridData}
                columns={gridColumns}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AmcReport;
